import Button from '@atoms/Button';
import Heading from '@atoms/Heading';
import ProgressBar from '@atoms/progressBar';
import React, { useState, useRef } from 'react';
import UploadZone from 'react-dropzone';

const FileUploader = ({
  uploadFileToS3andSave,
  element,
  uploadPercentage = 0,
  isUploadInProgress,
  mutiple = false,
  showProgress = true,
  maxSize = 104857600,
  maxSizeErrorMsg = 'File size more than allowed 100MB',
  tabIndex,
  accept = {
    'application/pdf': ['.pdf'],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
    'application/vnd.apple.keynote': ['.key'],
    'image/svg': ['.svg'],
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg']
  },
  updateCustomErrorMessage = (msg) => {},
  showDefaultErrorMessage = true
}) => {
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [uploadRejectMessage, setUploadRejectMessage] = useState('');
  const inputRef = useRef(null);

  return (
    <>
      <UploadZone
        disabled={
          isUploadInProgress
        }
        onDrop={async (acceptedFiles) => {
          if (!acceptedFiles.length) {
            setIsFileUploading(false);
            return;
          }
          if (acceptedFiles[0]?.size > maxSize) {
            setUploadRejectMessage(maxSizeErrorMsg);
            updateCustomErrorMessage(maxSizeErrorMsg);
            setIsFileUploading(false);
          } else if (!Object.values(accept).flat().includes(`.${acceptedFiles[0].name.slice(-6).split('.')[1]}`)) {
            setUploadRejectMessage('Please select proper file format');
            updateCustomErrorMessage('Please select proper file format');
            setIsFileUploading(false);
          } else {
            setUploadRejectMessage('');
            updateCustomErrorMessage('');
            setSelectedFile(acceptedFiles[0]);
            setIsFileUploading(true);
            await uploadFileToS3andSave(acceptedFiles);
          }
        }}
        noClick={(element && element.props.disabled) || isUploadInProgress}
        multiple={mutiple}
        accept={accept}
      >

        {({ getRootProps, getInputProps }) => (
          <div>
            {element ? (
              <div {...getRootProps({ tabIndex })}>
                {React.cloneElement(element, {
                  onClick: (e) => {
                    setIsFileUploading(false);
                    if (inputRef.current) inputRef.current.click();
                    if (element.props.onClick) element.props.onClick(e);
                  },
                })}
                <input
                  style={{ display: 'none' }}
                  {...getInputProps()}
                  ref={inputRef}
                />
              </div>
            ) : (
              <div>
                <div className='my-5' {...getRootProps({ tabIndex })}>
                  <input className="" onClick={() => setIsFileUploading(false)} {...getInputProps()} />
                  <Heading fontWeight='font-bold' type='subheading1' className='text-base font-semibold my-5'>Upload file</Heading>
                  <div className="text-center dropzone">
                    <img src="/images/Upload-Icon.svg" alt="Close-modal" className="my-4 mx-auto w-9 h-9 cursor-pointer" />
                    <p className="text-xs leading-4 font-normal">Click or drag and drop your files here. Supported formats: PDF, PPT, KEY, JPG, JPEG, PNG, SVG.</p>
                  </div>
                  <p className="my-4 text-center text-xs leading-4 font-normal">OR</p>
                  <Button
                    id="selectPdfBtnId"
                    type={isUploadInProgress ? 'disabled' : 'secondary'}
                    children="Upload file"
                    className={`w-full ${isUploadInProgress && 'bg-primary-50'}`}
                  />
                </div>
                <p className='my-4 text-center text-xs leading-4 font-normal text-neutral-60'>Upload PDFs, presentations (PPT, KEY), or images (JPG, JPEG, PNG, SVG). Files up to 100MB and 100 slides accepted.</p>
              </div>
            )}
            {showProgress && isFileUploading && isUploadInProgress
              && < div className="mt-16">
                <p className="text-xs font-semibold mb-1 break-all">{selectedFile?.name?.slice(0, 50)}{selectedFile?.name?.length > 50 ? '...' : ''}</p>
                <ProgressBar progress={uploadPercentage} />
                <p className='text-xs mt-1 w-full text-center'>Uploading {uploadPercentage}%</p>
              </div>
            }

            {
              showDefaultErrorMessage && (uploadRejectMessage.length > 0 && <p className="text-red-500 text-sm text-center font-bold">{uploadRejectMessage}</p>)
            }
          </div>
        )}
      </UploadZone >

    </>
  );
};

export default FileUploader;
